<ctx-log-thumbnail [log]="log()" />

<div class="log-row__information">
	<p class="m-0">
		{{ log().name }}
	</p>

	<small class="m-0">
		{{
			'data.last-edited-at'
				| transloco: { time: log().updatedAt | relativeTime }
		}}
	</small>
</div>

@if (parent(); as parent) {
	<div class="log-row__actions">
		<span tuiBadge appearance="info">
			@switch (parent.type) {
				@case ('file') {
					<tui-icon icon="@tui.sprout" />
				}
				@case ('folder') {
					<tui-icon icon="@tui.folder" />
				}
			}

			<span class="log-row__actions-badge-text">
				{{ parent.name }}
			</span>
		</span>

		<ng-content />
	</div>
}
